import script from "./backNav.vue?vue&type=script&setup=true&lang=js"
export * from "./backNav.vue?vue&type=script&setup=true&lang=js"

import "./backNav.vue?vue&type=style&index=0&id=2f1780c6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1780c6"]])

export default __exports__